import React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { staticURLs } from "../../config/urls";

const RedirectTrustPlusDialog = (props: any) => {
    const partnerName = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName) {
            return state.configurationState.configuration.partnerConfig.partnerDisplayName;
        }
    });
    const loginUserName: any = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo && state.loggedInUser.userInfo.loginUserName ? state.loggedInUser.userInfo.loginUserName : null
    );

    const handleRedirect = (e: any, RedirectLink: string) => {
        e.preventDefault();
        window.open(RedirectLink, "_blank");
        props.closeDialog();
    };

    return (
        <>
            <div className="dialog-header">
                <h1>Continue to TrustPlus?</h1>
            </div>
            <div className="dialog-body">
                <div className="row">
                    <p>You are about to leave {partnerName} identity protection platform to access TrustPlus. Are you sure you want to continue?</p>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row flex-end">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            onClick={(e: any) => {
                                handleRedirect(e, staticURLs.trustPlusURL);
                                window.addToDataLayer({ event: "Redirect TrustPlus Link Event" });
                            }}
                        >
                            <span className="btn-text">Yes, take me to TrustPlus</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RedirectTrustPlusDialog;
